// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__fxUI5","heading":"modal_heading__ETWEq","actions":"modal_actions__vym_J","backdrop":"modal_backdrop__Y5MNk","popup":"modal_popup__iwwhh"};